import api from "@/api/api-v2-config";

export async function getAppIdAxios() {
  return await api.get("marketings/getcred");
}

export async function postAppIdAxios(payload) {
  return await api.post("marketings/createcred", payload);
}

export async function putAppIdAxios(payload) {
  return await api.post("marketings/updatecred", payload);
}

export async function deleteAppIdAxios(id) {
  return await api.delete("marketings/deletecred", {
    params: { id }
  });
}


export async function pagePostsAxios(token) {
  return await api.get("marketings/facebook/getpagepost?token=" + token);
}

export async function deletePostsAxios(token, id) {
  return await api.delete(
    "marketings/facebook/deletepost?token=" + token + "&postid=" + id
  );
}

export async function getScheduledPostsAxios(token) {
  return await api.get(
    "marketings/facebook/getscheduledpagepost?token=" + token
  );
}

export async function postSocialPostsAxios(payload) {
  return await api.post("marketings/social/postnow", payload);
}

export async function postFacebookPostsAxios(payload) {
  return await api.post("marketings/facebook/pagepost", payload);
}

export async function postLinkedInPostsAxios(payload) {
  return await api.post("marketings/social/post", payload);
}

export async function getMarketingCampaignsAxios() {
  return await api.get(
    "marketings/getmarketingcampaignlist?PageNumber=1&PageSize=10000"
  );
}

export async function postMarketingCampaignAxios(payload) {
  return await api.post("marketings/createmarketingcampaign", payload);
}

export async function putMarketingCampaignAxios(payload) {
  return await api.put("marketings/updatemarketingcampaign", payload);
}

export async function getMarketingCampaignByIdAxios(id) {
  return await api.get("marketings/getcampaignbyid?id=" + id);
}

export async function deleteMarketingCampaignAxios(id) {
  return await api.delete("marketings/deletemarketingcampaign?id=" + id);
}

export async function updateMarketingCampaignStatusAxios(id, status) {
  return await api.put(
    `marketings/updatemarketingcampaignstatus/${id}?status=${status}`
  );
}

// campaign draft

export async function getCampaignDraftListAxios() {
  return await api.get(
    "marketings/getcampaigndraftlist?PageNumber=1&PageSize=10000"
  );
}

export async function getCampaignDraftByIdAxios(id) {
  return await api.get("marketings/getcampaigndraftbyid?id=" + id);
}

export async function getCampaignContentsByCampaignIdAxios(id) {
  return await api.get("marketings/getcampaigncontentsbycampaignid?id=" + id);
}

export async function postCampaignDraftAxios(payload) {
  return await api.post("marketings/createcampaigndraft", payload);
}

export async function putCampaignDraftAxios(payload) {
  return await api.put("marketings/updatecampaigndraft", payload);
}

export async function deleteCampaignAxios(id) {
  return await api.delete("marketings/deletecampaigndraft?id=" + id);
}

export async function postCampaignDraftPublishAxios(payload) {
  return await api.post("marketings/publishdraft", payload);
}

export async function getEventTaskListAxios() {
  return await api.get("marketings/gettasklist?PageNumber=1&PageSize=10000");
}

export async function postEventTaskAxios(payload) {
  return await api.post("marketings/createeventtask", payload);
}

export async function putEventTaskAxios(payload) {
  return await api.put("marketings/eventTaskstatus", payload);
}

//marketing cost
export async function getCostListAxios(id) {
  return await api.get("marketingmanagements/costlist?CampaignId=" + id);
}

export async function getCostByIDAxios(id) {
  return await api.get("marketingmanagements/cost?id=" + id);
}

export async function postCostAxios(payload) {
  return await api.post("marketingmanagements/cost", payload);
}

export async function putCostAxios(payload) {
  return await api.put("marketingmanagements/cost", payload);
}

export async function deleteCostAxios(id) {
  return await api.delete("marketingmanagements/cost?CostId=" + id);
}

//Task
export async function getTaskListAxios(id) {
  return await api.get("marketingmanagements/tasks?CampaignId=" + id);
}

export async function getTaskByIDAxios(id) {
  return await api.get("marketingmanagements/tasksbyid?id=" + id);
}

export async function postTaskAxios(payload) {
  const response = await api.post("marketingmanagements/tasks", payload);
  return response;
}

export async function putTaskAxios(payload) {
  return await api.put("marketingmanagements/tasks", payload);
}

export async function deleteTaskAxios(id) {
  return await api.delete("marketingmanagements/tasks?TaskId=" + id);
}

export async function getAssigneeListAxios() {
  return await api.get("marketingmanagements/assignees");
}

export async function putKPIAxios(payload) {
  return await api.put("marketingmanagements/campaignkpi",payload);
}

export async function postKPIAxios(payload) {
  return await api.post("marketingmanagements/campaignkpi", payload);
}

//marketing plan
export async function getMarketingPlanAxios() {
  return await api.get("marketings/marketingplan");
}

//contentTemplate
export async function getContentTemplateAxios(PlatformName) {
  return await api.get("marketingmanagements/getcontenttemplatelist?PlatformName=" + PlatformName);
}